export const NavigateForm = () => {
    window.location.href = '#application-form-section'
}